<i18n lang="yaml">
  en:
    submit: Next
    return: Previous
  fr:
    submit: Suivant
    return: Précédent
</i18n>
<template>
  <div :key="stepIndex" class="page-center">
    <form class="grid || space-pb-13 space-pb-0--s" @submit.prevent="submitHandler">
      <div class="grid__row grid__row--center">
        <div
          class="grid__col-10--xxs grid__push-1--xxs grid__col-8--s grid__push-2--s type-align-center"
        >
          <!-- eslint-disable vue/no-v-html -->
          <h1 class="space-mb-6 type-title-primary type-weight-700" v-html="getTranslation(title)" />
          <!-- eslint-enable vue/no-v-html -->
          <div class="space-mt-4 space-mb-2 type-align-center color-red">
            <span v-if="hasError">{{ step.error }}</span>
          </div>
        </div>
      </div>
      <div class="grid__row grid__row--center">
        <div class="grid__col-12--xxs type-align-center" :class="getClasses">
          <component
            :is="step.type"
            v-bind="props"
            :value="value"
            @input="val => inputHandler(val)"
          >
            <template v-slot:icon="{ option }">
              <vue-icon
                v-if="option.icon"
                class="space-mr-2 space-mr-0--s space-mb-3--s || display-block"
                :name="`icon-configurator-${option.icon}`"
              />
            </template>
          </component>
        </div>
      </div>
      <div v-if="stepIndex !== 0" class="grid__row grid__row--center">
        <div
          class="grid__col-10--xxs grid__push-1--xxs grid__col-6--s grid__push-3--s space-mb-4 space-mt-8"
        >
          <div class="flex justify-between">
            <nuxt-link
              :to="
                localePath({
                  name: 'economy-step',
                  params: { step: stepIndex },
                })
              "
              :title="$t('return')"
              class="link"
            >
              <vue-icon name="icon-arrow-left" class="space-mr-2" />
              {{ $t('return') }}
            </nuxt-link>
            <button :disabled="!isEnabled" type="submit" class="btn btn--primary">{{ $t('submit') }}</button>
          </div>
        </div>
      </div>
      <div v-else class="grid__row grid__row--center">
        <div class="grid__col-12--xxs space-mb-4 space-mt-8">
          <div class="flex justify-center">
            <button :disabled="!isEnabled" type="submit" class="btn btn--primary">{{ $t('submit') }}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FormRadio from '~/components/Configurator/FormRadio';
import FormRange from '~/components/Configurator/FormRange';
import FormText from '~/components/Form/FormText';
import VueIcon from '~/components/Icon';

export default {
  layout: 'configurator',
  nuxtI18n: {
    paths: {
      en: '/economy/:step',
      fr: '/economie/:step',
    },
  },
  components: {
    FormRadio,
    FormRange,
    FormText,
    VueIcon,
  },
  computed: {
    ...mapGetters('economy', {
      stepIndex: 'stepIndex',
      step: 'currentStep',
      isEnabled: 'currentStepHasValue',
    }),
    title() {
      return this.step.title;
    },
    getClasses() {
      return this.step.classes;
    },
    props() {
      return this.step.props;
    },
    value: {
      get() {
        return this.step.value;
      },
    },
    hasError() {
      return (
        {}.hasOwnProperty.call(this.step, 'error') && this.step.error.length > 0
      );
    },
  },
  created() {
    if (this.step.onCreate) {
      this.$store.dispatch(`economy/${this.step.onCreate}`);
    }
  },
  methods: {
    submitHandler() {
      if (this.step.onSubmit) {
        if (this.step.value === 0 || this.step.value === '') {
          return;
        }

        this.$store.dispatch(`economy/${this.step.onSubmit}`, this.stepIndex);
      }
    },
    inputHandler(value) {
      this.$store.dispatch('economy/updateStepValue', {
        index: this.stepIndex,
        value,
      });

      // zipcode submit exception
      if (this.stepIndex !== 4 && this.stepIndex !== 6) {
        this.submitHandler();
      }
    },
    getTranslation(object) {
      if (typeof object === 'string') {
        return object;
      }
      return object[this.$i18n.locale];
    },
  },
};
</script>
